import React from 'react'
import { Dots, Dot } from './ProgressDots.styles'
import type { ProgressDotsProps } from './ProgressDots.types'

const ProgressDots: React.FC<ProgressDotsProps> = ({
  currentDotIndex,
  numberOfDots,
  style
}) => (
  <Dots style={style}>
    {Array.from(Array(numberOfDots)).map((_, index) => (
      <Dot
        key={index}
        active={index === currentDotIndex}
        data-testid={`dot-${index}`}
      />
    ))}
  </Dots>
)

export default ProgressDots
